export const calendarDayOfWeek_Friday = "Dra";
export default {calendarDayOfWeek_Friday};